import { LanguageOption } from '../types/language-option';

export default class SelectBuilder {
  private readonly select: HTMLElement;

  constructor(languages: LanguageOption[]) {
    this.select = this.createSelectOptions(languages);
  }

  private createSelectOptions(languages: LanguageOption[]) {
    const select = document.createElement('select');

    for (const language of languages) {
      const option = document.createElement('option');
      option.value = language.value;
      option.innerText = language.label;
      select.append(option);
    }

    return select;
  }

  withDefaultValue(selectedValue: string) {
    const options = this.select.querySelectorAll('option');
    if (!options.length) return this;

    for (const option of options) {
      const isSelected = option.value === selectedValue;
      option.selected = isSelected;
      if (isSelected) break;
    }

    return this;
  }

  withOnSelect(onSelect: (language: string) => void) {
    this.select.addEventListener('change', e => {
      if (!e.target) return;
      if (!('value' in e.target) || typeof e.target.value !== 'string') return;
      onSelect?.(e.target?.value || '');
    });
    return this;
  }

  build() {
    return this.select;
  }
}
